import React from 'react';
import { P } from '@fashionnovateam/nova-ui-toolkit';
import { formatValue } from '../utils';

export function UnitsAdornment() {
  return (
    <P size="xs" color="disabled">
      units
    </P>
  );
}

export function WeeksAdornment() {
  return (
    <P size="xs" color="disabled">
      weeks
    </P>
  );
}

export function ShipmentModeBadge({ value }: { value: string }) {
  return (
    <span className="inline-flex items-center px-2 py-1 rounded-md bg-neutral-100 text-neutral-600 text-xs">
      {formatValue(value)}
    </span>
  );
}

export function ReadOnlyShipmentMode({
  isCompleted,
  value,
}: {
  isCompleted: boolean;
  value: string;
}) {
  if (isCompleted) {
    return <ShipmentModeBadge value={value} />;
  }
  return <P size="sm">{formatValue(value)}</P>;
}
